import React, { useMemo, useState } from "react";
import Tooltip from "./Tooltip";

const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="ml-1 text-grey-60"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
    <path d="M12 9h.01" />
    <path d="M11 12h1v4h1" />
  </svg>
);

function quadrantLabel(internalExternal, operationalStrategic) {
  const horiz = internalExternal >= 0 ? "External" : "Internal";
  const vert = operationalStrategic >= 0 ? "Operational" : "Strategic";
  return `${vert} - ${horiz}`;
}

const DominantQuadrantCard = ({ topicCloudData }) => {
  const dominant = useMemo(() => {
    const topics = Array.isArray(topicCloudData) ? topicCloudData : [];
    const scored = topics.filter(
      (t) =>
        typeof t.internalExternal === "number" &&
        typeof t.operationalStrategic === "number"
    );
    if (scored.length === 0) return null;

    const buckets = new Map(); // label -> weight
    scored.forEach((t) => {
      const f = t.frequency || t.value || 0;
      const w = typeof f === "number" ? f : 0;
      const label = quadrantLabel(t.internalExternal, t.operationalStrategic);
      buckets.set(label, (buckets.get(label) || 0) + w);
    });

    let best = null;
    for (const [label, weight] of buckets.entries()) {
      if (!best || weight > best.weight) best = { label, weight };
    }
    return best;
  }, [topicCloudData]);

  return (
    <div className="bg-white-f border border-grey-20 shadow-subtle rounded-lg px-5 py-4 w-[360px]">
      <div className="flex items-center gap-1 relative">
        <div className="text-sm font-normal text-black-0 tracking-[-0.5px]">
          Dominant quadrant
        </div>
        <Tooltip
          content={
            <>
              The quadrant where your organization’s topics most often land on the map,
              based on topic axis scoring (Strategic↔Operational and Internal↔External).
            </>
          }
          placement="bottom"
          align="start"
        >
          <span className="cursor-help inline-flex">
            <InfoIcon />
          </span>
        </Tooltip>
      </div>
      <div className="mt-1 text-[16px] font-semibold text-black-0 tracking-[-0.5px]">
        {dominant?.label || "No data"}
      </div>
    </div>
  );
};

export default DominantQuadrantCard;

